export function sendClarityEvent<T>(eventName: string, values: Date | string | Record<string, T> ) {
  window?.clarity("set", eventName, values);
}